import React from 'react';
import { motion } from 'framer-motion';
import { omnichannelSteps } from '../data/features';
import { Reveal, Stagger, staggerItem } from './MotionPrimitives';

const accents = [
  { badge: 'bg-violet-500/20 text-violet-300', dot: 'bg-violet-400', star: 'text-violet-400' },
  { badge: 'bg-orange-500/20 text-orange-300', dot: 'bg-orange-400', star: 'text-orange-400' },
  { badge: 'bg-sky-500/20 text-sky-300', dot: 'bg-sky-400', star: 'text-sky-400' },
  { badge: 'bg-emerald-500/20 text-emerald-300', dot: 'bg-emerald-400', star: 'text-emerald-400' },
];

export default function JourneyTimeline() {
  return (
    <section className="section-pad bg-black">
      <div className="mx-auto max-w-7xl">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="pill-dark">Daily Rhythm</span>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Your daily retail <span className="grad-text">loop</span>
          </h2>
          <p className="mt-4 text-mute">
            Dress the store, fill shelves, sell everywhere, deliver and recover. The same work you
            already do, now connected end to end.
          </p>
        </Reveal>

        <div className="relative mx-auto mt-16 max-w-4xl">
          <div className="absolute bottom-0 left-4 top-0 w-px bg-white/10 md:left-1/2 md:-translate-x-px" />

          <Stagger className="space-y-10">
            {omnichannelSteps.map((step, i) => {
              const a = accents[i % accents.length];
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={step.step}
                  variants={staggerItem}
                  className={`relative flex md:items-start ${left ? 'md:justify-start' : 'md:justify-end'}`}
                >
                  <div
                    className={`absolute left-4 z-10 flex h-8 w-8 -translate-x-1/2 items-center justify-center rounded-full ${a.dot} text-xs font-bold text-black md:left-1/2`}
                  >
                    {step.step}
                  </div>

                  <div
                    className={`ml-12 w-full rounded-2xl border border-white/10 bg-card p-5 md:ml-0 md:w-[calc(50%-2rem)] ${
                      left ? 'md:mr-auto md:pr-4' : 'md:ml-auto md:pl-4'
                    }`}
                  >
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${a.badge}`}>
                        Step {step.step}
                      </span>
                    </div>
                    <h3 className="mt-3 text-lg font-bold text-white">{step.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-mute">{step.body}</p>
                    <ul className="mt-4 space-y-1.5">
                      {step.notes.map((n) => (
                        <li key={n} className={`flex gap-2 text-sm text-mute`}>
                          <span className={a.star}>•</span>
                          {n}
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.div>
              );
            })}
          </Stagger>
        </div>
      </div>
    </section>
  );
}
